export enum signStatus {
  SIGNED = 'Firmado',
  PENDING = 'Pendiente'
}

export enum signStatusNum {
  SIGNED = 30,
  PENDING = 20
}
